import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

export interface RequestBody {
	recipeId: string;
}

export interface Response {
	data: ResponseData;
}

const MappingSchema = z.object({
	ingredientId: z.string(),
	productId: z.string().nullable(),
	sourceId: z.string().nullable(),
	segmentIndex: z.number(),
	name: z.string().nullable(),
	imageUrl: z.string().nullable(),
	price: z.number().nullable(),
	gtin: z.string().nullable(),
});

const ErpRecipeSchema = z.object({
	id: z.string(),
	name: z.string(),
	isFavorite: z.boolean(),
	createdDateUtc: z.string(),
	lastEditedDateUtc: z.string().nullable(),
	mappings: z.array(MappingSchema),
});

const ResponseDataSchema = z.array(ErpRecipeSchema);
const validator = createValidator(ResponseDataSchema);

export type ResponseData = z.infer<typeof ResponseDataSchema>;
export type ErpRecipe = z.infer<typeof ErpRecipeSchema>;
export type Mapping = z.infer<typeof MappingSchema>;

export async function callApi(request: RequestBody): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/erp/recipe/Search`;
	return (await axios.post(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
